import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { CreateNotificationApiService } from '../services/create-notification-api.service';
import * as savedSearchActions from '@saved-search/store/actions/saved-search.actions';

@Injectable()
export class CreateSavedSearchNotificationEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly createNotificationApiService: CreateNotificationApiService,
        private readonly userStoreService: UserStoreService
    ) { }

    public readonly createSavedSearchCreatedNotification$ = createEffect(() => this.actions$.pipe(
        ofType(savedSearchActions.createSavedSearchSuccess),
        concatLatestFrom(() => [this.userStoreService.customerCollaborationId$, this.userStoreService.customerId$]),
        switchMap(([{ savedSearchId }, collaborationId, customerId]) => this.createNotificationApiService.createSavedSearchCreatedNotification({
            collaborationId,
            customerId,
            savedSearchId
        }))
    ));
}